export var sizeKeys = ["default", "small"];
// eslint-disable-next-line no-shadow
export var OptionsAlign = /*#__PURE__*/function (OptionsAlign) {
  OptionsAlign["LEFT"] = "left";
  OptionsAlign["RIGHT"] = "right";
  return OptionsAlign;
}({});
export var defaultProps = {
  size: "default",
  optionsAlign: OptionsAlign.LEFT,
  hasTextEllipsis: false
};